<template>
  <div class="page-container">
    <div class="main-content" v-if="news">
      <article class="news-detail">
        <button @click="goBack" class="back-btn">
          <i class="fa fa-arrow-left"></i>
          <span>返回</span>
        </button>
        
        <div class="news-header">
          <h2 class="detail-title">{{ news.title }}</h2>
          <div class="detail-meta">
            <span class="detail-date">📅 创建时间：{{ news.createTime }}</span>
            <span class="detail-divider">|</span>
            <span class="detail-source">📰来源： {{ news.source }}</span>
            <span class="detail-divider">|</span>
            <span class="detail-author">👤作者：{{ news.username }}</span>
            <span class="detail-divider">|</span>
            <span class="detail-belong-label">归属：{{ news.belongText }}</span>
            <span class="detail-divider">|</span>
            <span class="detail-views">
              <i class="fa fa-eye"></i>
              {{ news.viewCount }}次浏览
            </span>
          </div>
        </div>
        
        <div class="detail-body" ref="detailBodyRef" v-html="news.content"></div>
      </article>
      
      <div class="action-bar">
        <button @click="goBack" class="back-btn-lg">
          <i class="fa fa-arrow-left"></i>
          返回资讯列表
        </button>
      </div>
    </div>
    
    <div v-else class="loading-state">
      <div class="loading-spinner"></div>
      <p>加载中...</p>
    </div>
    
    <div v-if="showLightbox" class="lightbox-overlay" @click="closeLightbox">
      <div class="lightbox-content" @click.stop>
        <button class="lightbox-close" @click="closeLightbox">
          <i class="fa fa-times"></i>
        </button>
        <img :src="lightboxImageSrc" alt="大图预览" class="lightbox-image" />
        <div class="lightbox-info">点击图片或关闭按钮退出</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getInformationDetail } from "@/api/newsApi";
import { baseURL } from "@/api/axiosConfig";

export default {
  name: "NewsCenterDetail",
  components: {},
  data() {
    return {
      news: null,
      newsId: null,
      showLightbox: false,
      lightboxImageSrc: ""
    };
  },
  mounted() {
    this.newsId = this.$route.params.id;
    if (this.newsId) {
      this.fetchNewsDetail();
    }
  },
  updated() {
    this.setupImageClickHandler();
  },
  methods: {
    addImageBaseUrl(content) {
      if (!content) return "";
      return content.replace(/<img[^>]+src="\/(dev-api\/)?profile\/upload\/[^"]+"/g, (match) => {
        return match.replace(/src="\/(dev-api\/)?profile\/upload\//, `src="${baseURL}/profile/upload/`);
      });
    },
    
    fetchNewsDetail() {
      getInformationDetail(this.newsId).then(response => {
        if (response.data.code === 200) {
          const data = response.data.data;
          // 处理原创/转载标识 (belongs: 0-原创, 1-转载)
          const belongs = data.belongs;
          const isOriginal = belongs === 0 || belongs === '0';
          
          this.news = {
            id: data.id,
            title: data.title,
            content: this.addImageBaseUrl(data.content),
            date: data.publishTime,
            viewCount: data.readingvolume,
            createTime: data.createTime || data.publishTime,
            source: data.source || '未知来源',
            username: data.username || '匿名作者',
            belongText: isOriginal ? '原创' : '转载'
          };
        }
      }).catch(error => {
        console.error('获取资讯详情失败:', error);
      });
    },
    
    goBack() {
      const from = this.$route.query.from;
      const page = this.$route.query.page;
      if (from === 'home') {
        this.$router.push('/');
      } else {
        // 返回资讯列表页，携带之前的页码
        if (page) {
          this.$router.push({
            path: '/news-center',
            query: { page: page }
          });
        } else {
          this.$router.push('/news-center');
        }
      }
    },
    
    setupImageClickHandler() {
      const detailBody = this.$refs.detailBodyRef;
      if (!detailBody) return;
      
      const images = detailBody.querySelectorAll('img');
      images.forEach(img => {
        if (!img.dataset.clickHandled) {
          img.dataset.clickHandled = 'true';
          img.style.cursor = 'pointer';
          img.style.maxWidth = '1150px';
          img.style.width = 'auto';
          img.addEventListener('click', (e) => {
            e.stopPropagation();
            this.openLightbox(img.src);
          });
          
          img.addEventListener('error', () => {
            img.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="%23ccc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"%3E%3Crect x="3" y="3" width="18" height="18" rx="2" ry="2"%3E%3C/rect%3E%3Ccircle cx="8.5" cy="8.5" r="1.5"%3E%3C/circle%3E%3Cpolyline points="21 15 16 10 5 21"%3E%3C/polyline%3E%3C/svg%3E';
          });
        }
      });
    },
    
    openLightbox(src) {
      this.lightboxImageSrc = src;
      this.showLightbox = true;
      document.body.style.overflow = 'hidden';
    },
    
    closeLightbox() {
      this.showLightbox = false;
      this.lightboxImageSrc = "";
      document.body.style.overflow = '';
    }
  }
};
</script>

<style scoped>
.page-container {
  margin-top: 60px;
  min-height: calc(100vh - 60px);
  background: linear-gradient(180deg, #f8f5fa 0%, #f0f4f8 100%);
  box-sizing: border-box;
}

.page-header {
  background: white;
  padding: 16px 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  position: sticky;
  top: 60px;
  z-index: 100;
}

.header-inner {
  max-width: 900px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.back-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  background: white;
  border: 1px solid #e0d6eb;
  border-radius: 10px;
  color: #7b1fa2;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  z-index: 10;
}

.back-btn:hover {
  background: linear-gradient(135deg, #7b1fa2 0%, #4a148c 100%);
  color: white;
  border-color: #7b1fa2;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(123, 31, 162, 0.25);
}

.page-title {
  font-size: 20px;
  color: #333;
  margin: 0;
  font-weight: 600;
  letter-spacing: 1px;
}

.header-placeholder {
  width: 80px;
}

.main-content {
  /* max-width: 1200px; */
  margin: 0 auto;
  padding: 30px 16px;
}

.news-detail {
  background: white;
  border-radius: 16px;
  padding: 30px 20px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  overflow-x: hidden;
  position: relative;
}

.news-header {
  padding-bottom: 24px;
  border-bottom: 2px solid #f0f0f0;
  margin-bottom: 28px;
}

.detail-title {
  font-size: 28px;
  color: #1a1a1a;
  margin: 0 0 20px 0;
  font-weight: 700;
  line-height: 1.4;
  letter-spacing: 0.5px;
}

.detail-meta {
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 14px;
  color: #888;
}

.detail-date {
  display: flex;
  align-items: center;
  gap: 6px;
}

.detail-divider {
  color: #ddd;
}

.detail-views {
  display: flex;
  align-items: center;
  gap: 6px;
}



.detail-body {
  font-size: 16px;
  color: #444;
  line-height: 2;
  word-break: break-all;
  overflow-x: hidden;
}

.detail-body p {
  margin: 0 0 20px 0;
  text-indent: 2em;
  text-align: justify;
}

.detail-body img {
  max-width: 900px !important;
  width: 100% !important;
  height: auto !important;
  display: block !important;
  margin: 20px auto;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.detail-body table {
  width: 100% !important;
  max-width: 100% !important;
  border-collapse: collapse;
  margin: 16px 0;
  table-layout: auto;
}

.detail-body table th,
.detail-body table td {
  padding: 6px 8px;
  border: 1px solid #e0e0e0;
  font-size: 11px;
  word-break: break-all;
  white-space: normal;
  word-wrap: break-word;
}

.detail-body table th {
  background: #f8f5fa;
  font-weight: 600;
  color: #333;
}

.detail-body table td a {
  color: #1989fa;
  text-decoration: none;
  word-break: break-all;
  white-space: pre-wrap;
  word-wrap: break-word;
  line-height: 1.4;
}

.detail-body table td a:hover {
  text-decoration: underline;
}

.detail-body img:hover {
  transform: scale(1.02);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
}

.detail-body h1,
.detail-body h2,
.detail-body h3,
.detail-body h4,
.detail-body h5,
.detail-body h6 {
  color: #222;
  font-weight: 600;
  margin: 28px 0 14px 0;
  padding-left: 16px;
  border-left: 4px solid #7b1fa2;
}

.detail-body h1 { font-size: 24px; }
.detail-body h2 { font-size: 22px; }
.detail-body h3 { font-size: 20px; }
.detail-body h4 { font-size: 18px; }
.detail-body h5 { font-size: 16px; }
.detail-body h6 { font-size: 14px; }

.detail-body strong {
  color: #7b1fa2;
  font-weight: 600;
}

.detail-body em {
  font-style: italic;
  color: #666;
}

.detail-body blockquote {
  margin: 20px 0;
  padding: 16px 20px;
  background: linear-gradient(135deg, #f8f5fa 0%, #f0f4f8 100%);
  border-left: 4px solid #7b1fa2;
  border-radius: 0 8px 8px 0;
  font-style: italic;
  color: #666;
}

.detail-body ul,
.detail-body ol {
  margin: 16px 0;
  padding-left: 32px;
}

.detail-body li {
  margin-bottom: 8px;
  line-height: 1.8;
}

.detail-body hr {
  margin: 30px 0;
  border: none;
  border-top: 1px dashed #ddd;
}

.action-bar {
  margin-top: 36px;
  text-align: center;
}

.back-btn-lg {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 14px 48px;
  background: linear-gradient(135deg, #7b1fa2 0%, #4a148c 100%);
  color: white;
  border: none;
  border-radius: 30px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  max-width: 900px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 16px rgba(123, 31, 162, 0.3);
}

.back-btn-lg:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(123, 31, 162, 0.4);
}

.back-btn-lg:active {
  transform: translateY(0);
}

.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 120px 20px;
}

.loading-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #f0f0f0;
  border-top-color: #7b1fa2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.loading-state p {
  font-size: 16px;
  color: #999;
  margin: 0;
}

@media (max-width: 1200px) {
  .main-content {
    max-width: calc(100% - 32px);
  }
}

@media (max-width: 768px) {
  .page-header {
    padding: 12px 16px;
  }
  
  .page-title {
    font-size: 18px;
  }
  
  .back-btn {
    padding: 8px 12px;
    font-size: 13px;
  }
  
  .header-placeholder {
    width: 60px;
  }
  
  .main-content {
    padding: 20px 12px;
    max-width: calc(100% - 24px);
  }
  
  .news-detail {
    padding: 20px 24px;
    border-radius: 12px;
  }
  
  .detail-title {
    font-size: 22px;
  }
  
  .detail-body {
    font-size: 15px;
    line-height: 1.9;
  }
  
  .detail-body p {
    text-indent: 1.5em;
  }
  
  .detail-body img {
    margin: 16px auto;
    border-radius: 8px;
  }
  
  .back-btn-lg {
    padding: 12px 32px;
    font-size: 15px;
  }
}

@media (max-width: 480px) {
  .detail-title {
    font-size: 20px;
  }
  
  .news-detail {
    padding: 16px;
  }
  
  .detail-meta {
    flex-wrap: wrap;
    gap: 10px;
  }
}

.lightbox-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  cursor: pointer;
  
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.lightbox-content {
  position: relative;
  max-width: 95vw;
  max-height: 95vh;
  cursor: default;
}

.lightbox-close {
  position: absolute;
  top: -40px;
  right: 0;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  font-size: 18px;
  cursor: pointer;
  
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.lightbox-close:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

.lightbox-image {
  max-width: 100%;
  max-height: 90vh;
  border-radius: 8px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.5);
  animation: zoomIn 0.3s ease;
}

@keyframes zoomIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.lightbox-info {
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  margin-top: 12px;
}

@media (max-width: 768px) {
  .lightbox-close {
    top: -50px;
    right: -10px;
  }
  
  .lightbox-content {
    max-width: 98vw;
    max-height: 98vh;
  }
  
  .lightbox-image {
    max-height: 85vh;
  }
}
</style>
